import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=31ce18bf&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatDialog.vue?vue&type=style&index=0&id=31ce18bf&prod&scoped=true&lang=scss"
import style1 from "./ChatDialog.vue?vue&type=style&index=1&id=31ce18bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce18bf",
  null
  
)

export default component.exports